import BaseButtonWrapper from '../../../common/BaseButtonWrapper';
import React from 'react';
import styles from './RemoveButton.scss';

const RemoveButton = (props) => {
  return (
    <BaseButtonWrapper {...props} className={styles['remove-button']}>
      <img alt={props['aria-label']} aria-hidden="true" src="/resources/assets/ui/nextgen/delete_outline.svg" />
      Remove
    </BaseButtonWrapper>
  );
};

export default RemoveButton;
